document.addEventListener("DOMContentLoaded", function () {
  const videoClose = document.querySelector(".video__close");
  const videoPopup = document.querySelector(".video__popup");
  const videoContainer = document.querySelector(".video__container");

  let lastFocusedElement = null;

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function trapFocus(e) {
    if (!videoPopup || videoPopup.hidden) return;
    if (e.key !== "Tab") return;

    const focusables = getFocusableElements(videoPopup);
    if (focusables.length === 0) {
      e.preventDefault();
      videoPopup.focus();
      return;
    }
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first || !videoPopup.contains(document.activeElement)) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function handleEscape(e) {
    if (e.key === "Escape" && videoPopup && !videoPopup.hidden) {
      closePopup();
    }
  }

  document.querySelectorAll(".video__wrapper").forEach((videoWrapper) => {
    const playButton = videoWrapper.querySelector(".video__start, .vc-play-button");

    const triggerOpen = (e, sourceEl) => {
      e.stopPropagation();
      const video = videoWrapper.querySelector("video");
      if (!video) return;
      lastFocusedElement = sourceEl || (e.currentTarget instanceof HTMLElement ? e.currentTarget : videoWrapper);
      openPopup(video);
    };

    if (playButton) {
      playButton.addEventListener("click", (e) => triggerOpen(e, playButton));
    } else {
      videoWrapper.addEventListener("click", (e) => triggerOpen(e, videoWrapper));
    }
  });

  if (videoClose) {
    videoClose.addEventListener("click", function (e) {
      e.stopPropagation();
      closePopup();
    });
  }

  if (videoPopup) {
    videoPopup.addEventListener("click", function (e) {
      if (e.target === videoPopup) {
        closePopup();
      }
    });
  }

  function closePopup() {
    if (!videoPopup) return;
    videoPopup.hidden = true;
    videoPopup.style.display = "none";
    videoContainer.innerHTML = "";
    document.removeEventListener("keydown", trapFocus, true);
    document.removeEventListener("keydown", handleEscape, true);
    if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
      lastFocusedElement.focus();
    }
  }

  function openPopup(video) {
    if (!videoPopup) return;
    videoPopup.hidden = false;
    videoPopup.style.display = "flex";
    videoContainer.innerHTML = `<video controls autoplay playsinline webkit-playsinline muted poster="${video.poster}" aria-label="Customer testimonial video">
      <source src="${video?.querySelector("src")?.src ? video.querySelector("src").src : video.getAttribute('data-video-src')}" type="video/mp4" />
    </video>`;

    const videoElement = videoContainer.querySelector("video");
    videoElement.playsInline = true;
    videoElement.webkitPlaysInline = true;
    videoElement.muted = true;

    videoElement.play().catch(function (error) {
      videoElement.removeAttribute('autoplay');
    });

    document.addEventListener("keydown", trapFocus, true);
    document.addEventListener("keydown", handleEscape, true);

    if (videoClose && typeof videoClose.focus === "function") {
      videoClose.focus();
    } else {
      videoPopup.focus();
    }
  }
});
